// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34rUU","type":"styles_type__AqCE1","choices":"styles_choices__1GHOE"};